@if (isModalOpen) {
  <app-modal
    [showHeader]="false"
    [showFooter]="false"
    [showCloseButton]="false"
    modalPopupClass=""
  >
    <div class="relative mx-auto w-[350px] p-6 px-10 sm:p-8">
      <div class="mb-5 flex justify-center">
        <div class="flex h-32 w-32 items-center justify-center">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="h-32 w-32"
            viewBox="0 0 24 24"
            fill="none"
            stroke="#6D03FE"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
            aria-hidden="true"
          >
            <circle cx="12" cy="12" r="9"></circle>
            <path d="M3 12h18"></path>
            <path d="M12 3c2.5 2.3 4 5.3 4 9s-1.5 6.7-4 9"></path>
            <path d="M12 3c-2.5 2.3-4 5.3-4 9s1.5 6.7 4 9"></path>
          </svg>
        </div>
      </div>

      <h2 class="mb-3 text-center text-lg font-bold text-primary">
        Please set your timezone.
      </h2>

      <p class="text-center text-sm text-secondary">
        Use the timezone option in the header to select your timezone and save it before continuing.
      </p>
      <div class="mt-2 flex justify-center">
        <app-button-fill
          title="Set Timezone"
          (buttonClick)="onSetTimezone()"
        ></app-button-fill>
      </div>
    </div>
  </app-modal>

}